import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from "nuxt/app";
import { AppRoutePaths, ROUTES_CONFIG } from "@/constants/appRoutes";
import { useUserProfileStore } from "@/store/userProfileStore";

export default defineNuxtRouteMiddleware(async (to) => {
  // skip middleware on server
  if (process.server) {
    return;
  }

  const queryNonce = to.query?.nonce as string;
  const userProfileStore = useUserProfileStore();
  if (queryNonce && userProfileStore.accessNonce !== queryNonce.toLowerCase()) {
    await userProfileStore.setAccessToken(queryNonce);
  }

  const result = await userProfileStore.setUserProfileAsync(); 
  if (!result) {
    return navigateTo(AppRoutePaths.landing, {redirectCode: 301});
  }

  if (userProfileStore.showBeamer) {
    (useNuxtApp() as unknown as { $initializeBeamer: () => void }).$initializeBeamer();
  }

  if (userProfileStore.showUserflow) {
    (useNuxtApp() as unknown as { $initializeUserflow: () => void }).$initializeUserflow();
  }

  const routeConfig = ROUTES_CONFIG.find((route) => route.name === to.name);
  if (routeConfig && routeConfig.featureName && !userProfileStore.hasFeature(routeConfig.featureName)) {
    const redirectPath = userProfileStore.hasFeature(AppRoutePaths.home)
      ? AppRoutePaths.home
      : AppRoutePaths.overview;
    return navigateTo(redirectPath, {redirectCode: 301});
  }

  if (to.query?.returnUrl) {
    if (queryNonce) {
      delete to.query.nonce;
    }
    const returnUrl = Array.isArray(to.query.returnUrl) ? to.query.returnUrl[0] : to.query.returnUrl;
    return navigateTo(returnUrl);
  }

  return;
});